import React from 'react';
import { Header } from '../components/Header';
import { Button } from '../components/Button';
import { SearchXIcon } from 'lucide-react';
interface EmptyScreenProps {
  onLogout: () => void;
  onClearFilters: () => void;
}
export function EmptyScreen({
  onLogout,
  onClearFilters
}: EmptyScreenProps) {
  return <div className="h-screen flex flex-col" data-id="element-53">
      <Header caseName="Smith v. Acme Corp" onLogout={onLogout} data-id="element-54" />

      <div className="flex-1 flex items-center justify-center p-4" data-id="element-55">
        <div className="text-center max-w-md" data-id="element-56">
          <div className="w-16 h-16 bg-navy-light rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-57">
            <SearchXIcon className="w-8 h-8 text-gray-500" data-id="element-58" />
          </div>
          <h2 className="text-2xl font-serif text-white mb-2" data-id="element-59">
            No documents found
          </h2>
          <p className="text-gray-400 mb-8" data-id="element-60">
            Try adjusting your search or filters to find what you're looking
            for.
          </p>
          <Button onClick={onClearFilters} data-id="element-61">Clear Filters</Button>
        </div>
      </div>
    </div>;
}